import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import { formatYearMonth } from '../ReportPDF/TaiwanDateConvert'

const handleDownload = async ({ reportData }) => {
  const { reprotDao, userPhishLog, userPhishLogTable, deptReportGroups, campaignStartDate } =
    reportData || {}
  const { companyName } = reprotDao || {}

  // 轉成 Excel 所需格式 釣中時間格式：YYYY/MM/DD HH：MM
  const formatDate = isoString => {
    const date = new Date(isoString)
    const pad = n => n.toString().padStart(2, '0')
    return `${date.getFullYear()}/${pad(date.getMonth() + 1)}/${pad(date.getDate())} ${pad(
      date.getHours(),
    )}:${pad(date.getMinutes())}`
  }

  const workbook = new ExcelJS.Workbook()

  /* ================  OO股份有限公司_釣中清單  start  ================ */

  const sheet1 = workbook.addWorksheet(`${companyName}_釣中清單`)

  // 標題與說明
  const title = '4.4.1 演練釣中清單'
  const description =
    '提供個別受測者「瀏覽郵件」、「點閱連結」、「開啟附件」與「輸入資料」之所有釣中時間清單。'
  const headers = ['公司名稱', '姓名', '電子郵件', '部門', '樣板', '釣中行為', '釣中時間']

  const dataRows = userPhishLogTable.map(log => [
    log.companyName || '',
    log.userName || '',
    log.userEmail || '',
    log.userDept || '',
    log.tempName || '',
    log.action || '',
    formatDate(log.time),
  ])

  sheet1.columns = [
    { key: 'companyName', width: 27 },
    { key: 'userName', width: 14 },
    { key: 'userEmail', width: 30 },
    { key: 'userDept', width: 23 },
    { key: 'tempName', width: 32 },
    { key: 'action', width: 12 },
    { key: 'time', width: 20 },
  ]

  // 填入標題與資料
  sheet1.addRow([title])
  sheet1.addRow([])
  sheet1.addRow([description])
  sheet1.addRow([])
  sheet1.addRow(headers)
  dataRows.forEach(row => sheet1.addRow(row))

  // 樣式設定
  sheet1.getRow(1).font = { name: '標楷體', size: 20, bold: true }
  sheet1.getRow(3).font = { name: '標楷體', size: 12 }

  const headerRow = sheet1.getRow(5)
  headerRow.font = { name: '標楷體', size: 10, bold: true, color: { argb: 'FFFFFFFF' } }
  headerRow.alignment = { vertical: 'middle', horizontal: 'center' }
  headerRow.height = 30
  headerRow.eachCell(cell => {
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF4F81BD' } }
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    }
  })

  // eslint-disable-next-line no-plusplus
  for (let i = 6; i <= sheet1.rowCount; i++) {
    sheet1.getRow(i).eachCell((cell, colNumber) => {
      // 設定底色與邊框
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD7E0ED' } }
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      }

      // 針對第7欄（釣中時間）設定字體為 Arial
      if (colNumber === 7) {
        cell.font = { name: 'Arial', size: 10 }
      } else {
        cell.font = { name: '標楷體', size: 10 }
      }

      // B~E 欄（第2~5欄）靠左，其他欄靠中
      if (colNumber >= 2 && colNumber <= 5) {
        cell.alignment = { vertical: 'middle', horizontal: 'left' }
      } else {
        cell.alignment = { vertical: 'middle', horizontal: 'center' }
      }
    })
  }

  /* ================  OO股份有限公司_釣中清單  end  ================ */

  /* ================  瀏覽郵件 點閱連結 開啟附件_結果清單  start  ================ */

  const sheet2 = workbook.addWorksheet('瀏覽郵件 點閱連結 開啟附件_結果清單')

  // 標題與說明
  const title2 = '4.4.2 受測者行為 結果清單'
  const description2 =
    '提供個別受測者依不同樣板的「瀏覽郵件」、「點閱連結」、「開啟附件」與「輸入資料」等釣中行為資訊。'
  const headers2 = [
    '姓名',
    '電子郵件',
    '部門',
    '樣板',
    '瀏覽郵件時間',
    '點閱連結時間',
    '開啟附件時間',
    '輸入資料時間',
  ]

  const dataRows2 = userPhishLog.map(log => [
    log.userName || '',
    log.userEmail || '',
    log.userDept || '',
    log.tempName || '',
    log.open ? formatDate(log.open) : '',
    log.link ? formatDate(log.link) : '',
    log.file ? formatDate(log.file) : '',
    log.text ? formatDate(log.text) : '',
  ])

  sheet2.columns = [
    { key: 'userName', width: 14 },
    { key: 'userEmail', width: 30 },
    { key: 'userDept', width: 23 },
    { key: 'tempName', width: 32 },
    { key: 'open', width: 21 },
    { key: 'link', width: 21 },
    { key: 'file', width: 21 },
    { key: 'text', width: 21 },
  ]

  // 填入標題與資料
  sheet2.addRow([title2])
  sheet2.addRow([])
  sheet2.addRow([description2])
  sheet2.addRow([])
  sheet2.addRow(headers2)
  dataRows2.forEach(row => sheet2.addRow(row))

  // 樣式設定
  sheet2.getRow(1).font = { name: '標楷體', size: 20, bold: true }
  sheet2.getRow(3).font = { name: '標楷體', size: 12 }

  const headerRow2 = sheet2.getRow(5)
  headerRow2.font = { name: '標楷體', size: 10, bold: true, color: { argb: 'FFFFFFFF' } }
  headerRow2.alignment = { vertical: 'middle', horizontal: 'center' }
  headerRow2.height = 30
  headerRow2.eachCell(cell => {
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF4F81BD' } }
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    }
  })

  // eslint-disable-next-line no-plusplus
  for (let i = 6; i <= sheet2.rowCount; i++) {
    sheet2.getRow(i).eachCell((cell, colNumber) => {
      // 共通樣式：底色與邊框
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD7E0ED' } }
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      }

      // A~D 欄（第1~4欄）靠左對齊
      if (colNumber >= 1 && colNumber <= 4) {
        cell.alignment = { vertical: 'middle', horizontal: 'left' }
        cell.font = { name: '標楷體', size: 10 }
      }
      // E~H 欄（第5~8欄）用 Arial 字體，置中對齊
      else if (colNumber >= 5 && colNumber <= 8) {
        cell.alignment = { vertical: 'middle', horizontal: 'center' }
        cell.font = { name: 'Arial', size: 10 }
      }
    })
  }

  /* ================  瀏覽郵件 點閱連結 開啟附件_結果清單  end  ================ */

  /* ================  部門釣中_結果清單  start  ================ */

  const sheet3 = workbook.addWorksheet('部門釣中_結果清單')

  // 標題與說明
  const title3 = '4.4.3 各部門釣中 結果清單'
  const description3 =
    '提供各部門釣中人數統計。統計部門內「瀏覽郵件」、「點閱連結」、「開啟附件」與「輸入資料」等數據。'
  const headers3 = [
    '排名',
    '部門',
    '部門受測人數',
    '部門被釣中人數',
    '瀏覽信件人數',
    '點閱連結人數',
    '開啟附件人數',
    '輸入資料人數',
  ]

  const dataRows3 = deptReportGroups.map(log => [
    log.groupId || '',
    log.groupName || '',
    log.report.userCount || '0',
    log.phishCount || '0',
    log.report.openCount || '0',
    log.report.linkCount || '0',
    log.report.fileCount || '0',
    log.report.textCount || '0',
  ])

  sheet3.columns = [
    { key: 'groupId', width: 8 },
    { key: 'groupName', width: 24 },
    { key: 'report.userCount', width: 16 },
    { key: 'phishCount', width: 18 },
    { key: 'report.openCount', width: 18 },
    { key: 'report.linkCount', width: 18 },
    { key: 'report.fileCount', width: 18 },
    { key: 'report.textCount', width: 18 },
  ]

  // 填入標題與資料
  sheet3.addRow([title3])
  sheet3.addRow([])
  sheet3.addRow([description3])
  sheet3.addRow([])
  sheet3.addRow(headers3)
  dataRows3.forEach(row => sheet3.addRow(row))

  // 樣式設定
  sheet3.getRow(1).font = { name: '標楷體', size: 20, bold: true }
  sheet3.getRow(3).font = { name: '標楷體', size: 12 }

  const headerRow3 = sheet3.getRow(5)
  headerRow3.font = { name: '標楷體', size: 10, bold: true, color: { argb: 'FFFFFFFF' } }
  headerRow3.alignment = { vertical: 'middle', horizontal: 'center' }
  headerRow3.height = 30
  headerRow3.eachCell(cell => {
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF4F81BD' } }
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    }
  })

  // eslint-disable-next-line no-plusplus
  for (let i = 6; i <= sheet3.rowCount; i++) {
    sheet3.getRow(i).eachCell((cell, colNumber) => {
      // 共通樣式
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD7E0ED' } }
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      }

      // 字體設定
      if (colNumber === 2) {
        // B欄：標楷體
        cell.font = { name: '標楷體', size: 10 }
      } else {
        // 其餘欄位：Arial
        cell.font = { name: 'Arial', size: 10 }
      }

      // 對齊設定
      if (colNumber === 1) {
        // A欄：置中
        cell.alignment = { vertical: 'middle', horizontal: 'center' }
      } else {
        // B～H欄：靠左
        cell.alignment = { vertical: 'middle', horizontal: 'left' }
      }
    })
  }

  /* ================  部門釣中_結果清單  end  ================ */

  // 產生並下載 Excel
  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  // OO股份有限公司_社交工程郵件演練服務結果_各類清單_YYYYMM
  return saveAs(
    blob,
    `${companyName}_社交工程郵件演練服務結果_各類清單_${formatYearMonth(campaignStartDate)}.xlsx`,
  )
}

export default handleDownload
